import { Suspense, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoadingSpinner from "../components/UIComponents/LoadingSpinner";
import { routes } from "./routes";

// Protected route wrapper
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  // TODO: Implement authentication logic
  const isAuthenticated = true; // Replace with actual auth check

  if (!isAuthenticated) return <Navigate to="/" replace />;

  return <>{children}</>;
};

// Helper function to render routes recursively
const renderRoutes = (routeConfigs: typeof routes) => {
  return routeConfigs.map(route => {
    const RouteElement = route.element;
    const routeElement = route.protected ? (
      <ProtectedRoute>
        <RouteElement />
      </ProtectedRoute>
    ) : (
      <RouteElement />
    );

    return (
      <Route key={route.path} path={route.path} element={routeElement}>
        {route.children && renderRoutes(route.children)}
      </Route>
    );
  });
};

const AppRouter = () => {
  const ScrollToTop = () => {
    const location = useLocation();
    useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [location.pathname]);
    return null;
  };

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {renderRoutes(routes)}
          {/* Catch all route - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default AppRouter;
